<iframe *ngIf="url" [src]="url" style="border:none;" height="245" width="100%"></iframe>
